import { render, staticRenderFns } from "./AddressSelectionPage.vue?vue&type=template&id=0063d1c3&scoped=true"
import script from "./AddressSelectionPage.vue?vue&type=script&lang=js"
export * from "./AddressSelectionPage.vue?vue&type=script&lang=js"
import style0 from "./AddressSelectionPage.vue?vue&type=style&index=0&id=0063d1c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0063d1c3",
  null
  
)

export default component.exports